<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card class="list-view-item overflow-hidden" v-on="$listeners">
    <template slot="no-body">
      <vx-tooltip
        :text="
          item.hasOwnProperty('status_published')
            ? item.status_published
              ? 'Published'
              : 'Unpublished'
            : 'Published'
        "
        position="bottom"
        delay=".3s"
        class="m-2 h-4 w-4 right-0 status-dot"
      >
        <div
          class="h-4 w-4 rounded-full"
          :class="{
            'gray-color': item.hasOwnProperty('status_published')
              ? item.status_published == false
              : false,
            'purple-color': item.hasOwnProperty('status_published')
              ? item.status_published
              : true,
          }"
        />
      </vx-tooltip>
      <div class="hamburger-icon">
        <vs-icon
          icon="menu"
          v-if="is_swap_enable"
          style="font-size: 24px"
          class="p-2 mr-8"
        />
      </div>

      <div class="vx-row item-details no-gutter">
        <!-- IMG COL -->
        <div
          class="vx-col sm:w-1/4 w-full item-img-container bg-white flex items-center justify-center cursor-pointer"
          @click="navigate_to_detail_view"
        >
          <img
            v-if="item.video_url"
            :src="getYouTubeThumbnail(item.video_url)"
            :alt="item.category"
            class="grid-view-img"
            :class="{
              'small-image': is_swap_enable,
              'p-4': is_swap_enable == false,
            }"
          />
          <img
            v-else
            src="@/assets/images/logo/DHP Logo no text.png"
            class="grid-view-img px-4"
          />
        <!-- <p>{{item.order}}</p> -->

        </div>

        <!-- ITEM NAME & DESC COL -->
        <div class="vx-col sm:w-1/2">
          <div class="p-4 pt-6">
            <slot name="item-meta">
              <h6
                class="truncate font-semibold mb-1 hover:text-primary cursor-pointer"
                @click="navigate_to_detail_view"
              >
                {{ item.category }}
              </h6>
              <p class="item-description truncate text-sm">
                {{ item.video_title }}
              </p>
            </slot>
          </div>
        </div>

        <!-- PURCHASE COL -->
        <div
          class="vx-col sm:w-1/4 w-full flex items-center sm:border border-0 border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0"
        >
          <div class="p-4 flex flex-col w-full">
            <!-- <div class="text-warning flex self-end border border-solid border-warning py-1 px-2 rounded">
                            <span class="text-sm mr-1">{{ item.rating }}</span>
                            <feather-icon icon="StarIcon" svgClasses="h-4 w-4" />
                        </div> -->

            <!-- <div class="my-6">
                            <h5 class="font-bold text-center">${{ item.price }}</h5>
                            <span class="text-grey flex items-start justify-center mt-1" v-if="item.free_shipping">
                                <feather-icon icon="ShoppingCartIcon" svgClasses="w-4 h-4" />
                                <span class="text-sm ml-2">Free Shipping</span>
                            </span>
                        </div> -->

            <slot name="action-buttons" />
          </div>
        </div>
      </div>
    </template>
  </vx-card>
</template>

<script>
import DataProvider from "../../../../services/data-provider";
import Constant from "../../../../services/constant";
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    is_swap_enable: {
      type: Boolean,
    },
  },
  computed: {
    isInCart() {
      return (itemId) => this.$store.getters["eCommerce/isInCart"](itemId);
    },
    isInWishList() {
      return (itemId) => this.$store.getters["eCommerce/isInWishList"](itemId);
    },
  },
  methods: {
    toggleItemInWishList(item) {
      this.$store.dispatch("eCommerce/toggleItemInWishList", item);
    },
    getYouTubeThumbnail(url) {
      const id = DataProvider.getYouTubeId(url);
      return Constant.you_tube_thumbnail_url + id + Constant.image_type;
    },
    additemInCart(item) {
      this.$store.dispatch("eCommerce/additemInCart", item);
    },
    cartButtonClicked(item) {
      this.isInCart(item.id)
        ? this.$router.push("/apps/eCommerce/checkout").catch(() => {})
        : this.additemInCart(item);
    },
    navigate_to_detail_view() {
      this.$router
        .push({
          name: "health-hacks-item-detail-view",
          params: { category: this.item.category, item_id: this.item.id },
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.list-view-item {
  .item-name,
  .item-description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .hamburger-icon {
    position: absolute;
    right: 0;
    top: 25%;
  }
  .small-image {
    width: 100px !important;
  }

  .item-name {
    -webkit-line-clamp: 2;
  }

  .item-description {
    -webkit-line-clamp: 5;
  }

  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: 0.35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
  h6.truncate {
    text-transform: capitalize;
  }
  .purple-color {
    // background-color: #7367f0;
    background-color: green;
  }
  .gray-color {
    background-color: #e2e2e2;
  }
}
</style>
